/**
 * The stylesheets every member-facing loop page depends on, as render-blocking
 * head links (OL-312).
 *
 * Every sheet arrives through a `?url` import, which resolves to a hashed,
 * immutable asset the server can name in the `<head>` it sends: a
 * parser-encountered `<link rel="stylesheet">` blocks first paint, so the loops
 * index paints styled rather than painting raw and then jumping into place. A
 * side-effect `import "./x.css"` from a `.lazy.tsx` chunk cannot do that (see
 * `packages/web/CLAUDE.md` → performance budgets, rule 6).
 *
 * `fonts.css` is deliberately NOT linked: it is a cross-origin `@import` of the
 * Google Fonts css2 endpoint, which stays async with the metric-matched fallback
 * faces in `globals.css`.
 *
 * @since 1.0.0
 */
import loopFlowCss from "~/components/loops/loop-flow.css?url";
import type { HeadLink } from "~/config/head.ts";
import { orcaloopsStylesheetLinks } from "./orcaloops-head.ts";

/**
 * The loop page sheet: the orcaloops frame sheet (`orcaloops-head.ts`), which
 * styles the member frame every loop page mounts.
 *
 * @since 1.0.0
 */
export const loopShellStylesheetLinks: Array<HeadLink> = [...orcaloopsStylesheetLinks];

/**
 * The loop page sheet plus the loop-flow sheet, for the pages that draw a loop
 * (the canvas / viewer), which need the member frame AND the graph.
 *
 * @since 1.0.0
 */
export const loopViewerStylesheetLinks: Array<HeadLink> = [
  ...loopShellStylesheetLinks,
  { rel: "stylesheet", href: loopFlowCss },
];
